/**
 * Everything the iPad keeps locally (IndexedDB): device info, mechanic list, offline PIN
 * verifiers, each mechanic's last job list, and the ordered queue of unsent actions.
 */
import { openDB, type DBSchema, type IDBPDatabase } from 'idb';
import type { SyncItem } from '@wo/shared';

export interface QueuedFile {
  clientId: string;
  blob: Blob;
  headers: Record<string, string>;
}

export interface QueueEntry {
  seq?: number;
  clientId: string;
  userId: number;
  label: string;
  createdAt: number;
  item?: SyncItem;
  file?: QueuedFile;
}

export interface Problem {
  clientId: string;
  userId: number;
  label: string;
  message: string;
  at: number;
}

interface WoDb extends DBSchema {
  kv: { key: string; value: unknown };
  queue: { key: number; value: QueueEntry; indexes: { byUser: number } };
  problems: { key: string; value: Problem };
}

let dbp: Promise<IDBPDatabase<WoDb>> | null = null;
export function db() {
  dbp ??= openDB<WoDb>('wo-mechanic', 1, {
    upgrade(d) {
      d.createObjectStore('kv');
      d.createObjectStore('queue', { keyPath: 'seq', autoIncrement: true }).createIndex('byUser', 'userId');
      d.createObjectStore('problems', { keyPath: 'clientId' });
    },
  });
  return dbp;
}

export const kvGet = async <T>(key: string) => (await (await db()).get('kv', key)) as T | undefined;
export const kvSet = async (key: string, value: unknown) => (await db()).put('kv', value, key);

export const newClientId = () => crypto.randomUUID().replace(/-/g, '');
